
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/audio-visual-service",
      function () {
        return require("private-next-pages/events/audio-visual-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/audio-visual-service"])
      });
    }
  